import { createAsyncAction, createAction } from 'typesafe-actions';
import { AxiosError } from 'axios';
import {
  GetSimilarImageParamType,
  GetSimilarImageResponseType,
} from '../../lib/tabSimilarImage/type';

export const GET_SIMILAR_IMAGE = 'tabSimilarImage/GET_SIMILAR_IMAGE' as const;
export const GET_SIMILAR_IMAGE_SUCCESS = 'tabSimilarImage/GET_SIMILAR_IMAGE_SUCCESS' as const;
export const GET_SIMILAR_IMAGE_ERROR = 'tabSimilarImage/GET_SIMILAR_IMAGE_ERROR' as const;

export const SET_SIMILAR_IMAGE_DATA_NULL = 'tabSimilarImage/SET_SIMILAR_IMAGE_DATA_NULL' as const;

export const getSimilarImageAsync = createAsyncAction(
  GET_SIMILAR_IMAGE,
  GET_SIMILAR_IMAGE_SUCCESS,
  GET_SIMILAR_IMAGE_ERROR
)<GetSimilarImageParamType, GetSimilarImageResponseType, AxiosError>();

export const setSimilarImageDataNull = createAction(
  SET_SIMILAR_IMAGE_DATA_NULL
)();
